var _path, _path2, _rect, _rect2, _g, _rect3, _g2, _path3, _path4, _path5, _path6, _path7, _rect4, _rect5, _g3, _rect6, _g4, _rect7, _path8, _rect8, _g5, _rect9, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpaLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_1502)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0729 0.682657C13.7887 0.261338 14.6766 0.261338 15.3924 0.682657L27.3359 7.71289C28.0339 8.12374 28.4624 8.87323 28.4624 9.68316V22.3167C28.4624 23.1266 28.0339 23.8761 27.3359 24.2869L15.3924 31.3172C14.6766 31.7385 13.7887 31.7385 13.0729 31.3172L1.12943 24.2869C0.431448 23.8761 0.00292969 23.1266 0.00292969 22.3167V9.68315C0.00292969 8.87323 0.431448 8.12375 1.12943 7.71289L13.0729 0.682657Z",
    fill: "#F2F4FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_349_1502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.07 0.682657C13.7857 0.261338 14.6737 0.261338 15.3895 0.682657L27.3329 7.71289C28.0309 8.12374 28.4594 8.87323 28.4594 9.68316V22.3167C28.4594 23.1266 28.0309 23.8761 27.3329 24.2869L15.3895 31.3172C14.6737 31.7385 13.7857 31.7385 13.07 31.3172L1.12651 24.2869C0.428519 23.8761 0 23.1266 0 22.3167V9.68315C0 8.87323 0.428518 8.12375 1.1265 7.71289L13.07 0.682657Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_349_1502)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.09668,
    y: 15.2285,
    width: 2.5524,
    height: 14.853,
    fill: "#3940A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_349_1502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 6,
    height: 4
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5186,
    y: 9.625,
    width: 2.40657,
    height: 5.1048,
    transform: "rotate(90 14.5186 9.625)",
    fill: "#CD6767"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_349_1502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.41376 12.0316C9.41376 11.7155 9.47978 11.4026 9.60805 11.1106C9.73632 10.8186 9.92433 10.5533 10.1613 10.3299C10.3983 10.1064 10.6797 9.92913 10.9894 9.80819C11.2991 9.68725 11.631 9.625 11.9662 9.625L11.9662 12.0316L9.41376 12.0316Z",
    fill: "#3940A0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_349_1502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 9,
    width: 7,
    height: 4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.0558,
    y: 9.625,
    width: 2.40657,
    height: 5.1048,
    rx: 0.142891,
    transform: "rotate(90 19.0558 9.625)",
    fill: "#CD6767"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_349_1502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0939 12.0316C14.015 12.0316 13.9505 11.9675 13.9555 11.8888C13.9924 11.3026 14.2557 10.7474 14.6986 10.3299C15.1772 9.87855 15.8264 9.625 16.5034 9.625C17.1803 9.625 17.8295 9.87855 18.3082 10.3299C18.751 10.7474 19.0144 11.3026 19.0513 11.8888C19.0563 11.9675 18.9918 12.0316 18.9129 12.0316L16.5034 12.0316L14.0939 12.0316Z",
    fill: "#3940A0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6444 18.5371C15.7233 18.5371 15.7873 18.6011 15.7873 18.68L15.7873 20.8008C15.7873 20.8797 15.7233 20.9437 15.6444 20.9437L8.64855 20.9437L8.64855 18.5371L15.6444 18.5371Z",
    fill: "#3940A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0645 21.6582L16.5121 21.6582L16.5121 16.0103C16.5121 15.9314 16.576 15.8674 16.6549 15.8674L18.9216 15.8674C19.0005 15.8674 19.0645 15.9314 19.0645 16.0103L19.0645 21.6582Z",
    fill: "#3940A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4082 12.0312L11.9606 12.0312L11.9606 17.6792C11.9606 17.7581 11.8966 17.8221 11.8177 17.8221L9.55109 17.8221C9.47218 17.8221 9.4082 17.7581 9.4082 17.6792L9.4082 12.0312Z",
    fill: "#3940A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8162 12.7461L19.8162 15.1527L12.8603 15.1527C12.7813 15.1527 12.7174 15.0887 12.7174 15.0098L12.7174 12.889C12.7174 12.8101 12.7813 12.7461 12.8603 12.7461L19.8162 12.7461Z",
    fill: "#3940A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5127 21.6582L16.5127 24.0648L9.41383 24.0648L9.41384 21.8011C9.41384 21.7222 9.47781 21.6582 9.55673 21.6582L16.5127 21.6582Z",
    fill: "#3940A0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4727,
    y: 9.625,
    width: 2.40657,
    height: 4.50658,
    transform: "rotate(90 16.4727 9.625)",
    fill: "#3940A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_349_1502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 12,
    width: 4,
    height: 6
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3643,
    y: 17.5605,
    width: 2.5524,
    height: 4.81314,
    transform: "rotate(-180 22.3643 17.5605)",
    fill: "#CD6767"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_349_1502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8119 12.7474C20.4888 12.7474 21.138 13.001 21.6167 13.4523C22.0953 13.9036 22.3643 14.5157 22.3643 15.154L19.8119 15.154L19.8119 12.7474Z",
    fill: "#3940A0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_349_1502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 17,
    width: 4,
    height: 5
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3711,
    y: 21.8457,
    width: 2.5524,
    height: 4.81314,
    rx: 0.142891,
    transform: "rotate(-180 22.3711 21.8457)",
    fill: "#CD6767"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_349_1502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8187 17.1755C19.8187 17.0965 19.8827 17.0322 19.9615 17.0363C20.5864 17.0693 21.1786 17.318 21.6235 17.7374C22.1022 18.1888 22.3711 18.8009 22.3711 19.4391C22.3711 20.0774 22.1022 20.6895 21.6235 21.1408C21.1786 21.5603 20.5864 21.8089 19.9615 21.8419C19.8827 21.8461 19.8187 21.7817 19.8187 21.7028L19.8187 19.4391L19.8187 17.1755Z",
    fill: "#3940A0"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3711,
    y: 19.4395,
    width: 2.5524,
    height: 4.2867,
    transform: "rotate(-180 22.3711 19.4395)",
    fill: "#3940A0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41406 24.0645H11.9665L11.9665 31.5925C11.9665 31.6714 11.9025 31.7354 11.8236 31.7354H9.55695C9.47804 31.7354 9.41406 31.6714 9.41406 31.5925L9.41406 24.0645Z",
    fill: "#3940A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_349_1502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 3,
    height: 6
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.09668,
    y: 12.8223,
    width: 2.5524,
    height: 4.81314,
    rx: 0.142891,
    fill: "#CD6767"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_349_1502)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.64908,
    cy: 15.2288,
    rx: 2.5524,
    ry: 2.40657,
    fill: "#3940A0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_349_1502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 21,
    width: 4,
    height: 4
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5127,
    y: 24.0645,
    width: 2.40657,
    height: 2.5524,
    transform: "rotate(-90 16.5127 24.0645)",
    fill: "#CD6767"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_349_1502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.056 21.6579C19.056 21.9739 18.99 22.2869 18.8617 22.5788C18.7334 22.8708 18.5454 23.1361 18.3084 23.3596C18.0714 23.5831 17.79 23.7603 17.4803 23.8813C17.1707 24.0022 16.8388 24.0645 16.5036 24.0645L16.5036 21.6579L19.056 21.6579Z",
    fill: "#3940A0"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_1502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpaLogoIcon);
export default __webpack_public_path__ + "static/media/ppa-logo-icon.8125b5086ec885b913f5503157cfd60b.svg";
export { ForwardRef as ReactComponent };